import React from 'react';
import D3Format from './D3Format.js';

class TreeToggle extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			'isExpanded': props.isExpanded
		}
	}

	toggleIcon(state) {
		if(state === 'collapse') {
			this.setState({
				'isExpanded': false
			});
			this.props.onCollapse();
		}
		else {
			this.setState({
				'isExpanded': true
			});
			this.props.onExpand();
		}
	}

	render() {
		if(this.state.isExpanded) {
			return (<i className="fa fa-minus tree-node-icon" onClick={this.toggleIcon.bind(this, 'collapse')}></i>);
		}
		else {
			return (<i className="fa fa-plus tree-node-icon" onClick={this.toggleIcon.bind(this, 'expand')}></i>);
		}
	}
}

TreeToggle.defaultProps = {
	isExpanded: true,
	onExpand: () => {},
	onCollapse: () => {}
};

class QueryStatusComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hiddenTree: {
				main: false
			}
		};
	}

	onExpand(key) {
		console.log('onExpand', key);
		var obj = {};
		obj[key] = false;
		this.setState({
			hiddenTree: Object.assign({}, this.state.hiddenTree, obj)
		});
	}

	onCollapse(key) {
		console.log('onCollapse', key);
		var obj = {};
		obj[key] = true;
		this.setState({
			hiddenTree: Object.assign({}, this.state.hiddenTree, obj)
		});
	}

	renderSubQueries(model) {
		var subqueryText = (this.props.subqueryText + ' ') || '서브 쿼리 ';
		var elsLi = model.map((sq, i) => {
			var key = `sub${i}`;
			var elsCommands;
			if(!this.state.hiddenTree[key]) {
				elsCommands = this.renderCommands(sq.commands);
			}

			return (
				<li key={'_subq_' + i}>
					<a>
						<TreeToggle
							isExpanded={!this.state.hiddenTree[key]}
							onExpand={this.onExpand.bind(this, key)}
							onCollapse={this.onCollapse.bind(this, key)}></TreeToggle>
						<i className="tree-node-icon icon-ok"></i>
						{subqueryText}{sq.id}
					</a>
					{elsCommands}
				</li>
			);
		})
		return elsLi;
	}


	renderCommands(model) {
		var passText = (' ' + this.props.passText) || 'passes';
		var elsLi = model.map((cmd, i) => {

			var elStatus = (<i className="tree-node-icon fa fa-spinner fa-spin"></i>);
			if(cmd.status === 'Finalizing') {
				elStatus = (<i className="tree-node-icon fa fa-spinner fa-pulse"></i>);
			}
			else if(cmd.status === 'End') {
				elStatus = (<i className="tree-node-icon icon-ok"></i>);
			}


			return (
				<li key={'_cmd_' + i}>
					<a>
						<i className="fa fa-terminal tree-node-icon"></i>
						{elStatus}
						<span className="rendered-command">{cmd.command}</span>
						<span className="pull-right" style={{paddingRight: '5px'}}>
							<i>{D3Format.number(cmd.push_count)}</i>
							{passText}
						</span>
					</a>
				</li>
			)
		})
		return (
			<ul className="nav nav-list hello">
				{elsLi}
			</ul>
		)
	}

	render() {
		var model = this.props.model;
		var queryText = (this.props.queryText + ' ') || '쿼리 ';
		// console.log(model);

		var elsSubQueries = this.renderSubQueries(model.sub_queries);
		var elsCommands;
		if(!this.state.hiddenTree.main){
			elsCommands = this.renderCommands(model.commands);
		}

		var elStatus = (<i className="tree-node-icon fa fa-spinner fa-spin"></i>);
		if(model.is_end) {
			elStatus = (<i className="tree-node-icon icon-ok"></i>);
		}

		return (
			<ul className="nav nav-list world">
				<li>
					<a>
						<TreeToggle
							isExpanded={!this.state.hiddenTree.main}
							onExpand={this.onExpand.bind(this, 'main')}
							onCollapse={this.onCollapse.bind(this, 'main')}></TreeToggle>
						{elStatus}
						<span>{queryText}{model.id}</span>
					</a>
					{elsCommands}
				</li>
				{elsSubQueries}
			</ul>
		);
	}
}

export default QueryStatusComponent;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/ui/QueryStatusComponent.jsx